import React from "react";
import { Link, useParams } from "react-router-dom";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: "1rem",
};

export default function ProviderStylistDetailPage() {
  const { stylistId } = useParams();

  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <h2 style={{ margin: 0, color: "#0f172a" }}>
          Stylist detail {stylistId ? `· ${stylistId}` : ""}
        </h2>
        <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
          Review stylist profile, schedule context, supported services, and readiness summary.
        </p>
      </section>

      <section style={cardStyle}>
        <div style={{ display: "grid", gap: "0.7rem", color: "#334155" }}>
          <div><strong>Name:</strong> Demo stylist</div>
          <div><strong>Role:</strong> Senior stylist</div>
          <div><strong>Experience:</strong> 5 years</div>
          <div><strong>Specialties:</strong> Haircut, styling, beard grooming</div>
          <div><strong>Assigned services:</strong> 3</div>
          <div><strong>Status:</strong> Pending profile finalization</div>
        </div>
      </section>

      <section style={cardStyle}>
        <Link
          to="/provider/dashboard/stylists"
          style={{
            textDecoration: "none",
            border: "1px solid #d1d5db",
            borderRadius: 12,
            padding: "0.75rem 1rem",
            color: "#111827",
            fontWeight: 700,
            display: "inline-flex",
          }}
        >
          Back to stylists
        </Link>
      </section>
    </div>
  );
}